module.exports = __webpack_public_path__ + "img/TS6101-306.7979ec14.jpg";